import React from "react";
import { Box, Typography } from "@mui/material";

const Heading = ({ title, subTitle, color }) => {
  return (
    <Box sx={[styles.RootContainer]}>
      <Typography sx={[styles.HeadingTxt, { color }]}>{title}</Typography>

      <Box sx={[styles.SubHeadingTxtContainer]}>
        <Typography sx={[styles.SubHeadingTxt]}>{subTitle}</Typography>
      </Box>
    </Box>
  );
};

export default Heading;

const styles = {
  RootContainer: { padding: "0px 8px" },
  HeadingTxt: {
    fontWeight: "600",
    fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.45rem" },
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins", serif',
    WebkitTextFillColor: "transparent",
    textTransform: "none",
    // textAlign: "left",
  },
  SubHeadingTxtContainer: {
    textAlign: "center",
    align: "center",
  },
  SubHeadingTxt: {
    color: "grey",
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins", serif',
    textAlign: "justify",
    // width: { xs: "100%", sm: "100%", md: "91%" },
    width: { xs: "100%", sm: "100%", md: "96%" },
  },
};
